module.exports = __webpack_public_path__ + "img/ico_menual03_on.901a3740.svg";